import React, { useState, useEffect,useRef } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./municipality.css";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const FilterTableUI = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ searchKey: "" });
  const [districts, setDistricts] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

   const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
     const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
const [csvFile, setCsvFile] = useState(null);
const [previewData, setPreviewData] = useState([]);
const [csvErrors, setCsvErrors] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
    const [circleList, setcircleList] = useState([]);


  const [formData, setFormData] = useState({
    user_id: "",
    district_id: "",
    // sub_division_id: "",
    name: "",
    municipality_code: "",
    //   mobile: "",
    //   email: "",
    // circle_id: "",
    password: "",
    confirm_password: "",
    address: ""
  });




  const navigate = useNavigate();

  const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });


  const loadDistricts = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/districtMasterList`,
        {}, getAuthHeader());
      setDistricts(res.data?.data || []);
      setPage(res.data.page|| 1);
      setTotalPages(res.data.total_records || 0);
    } catch (err) {
      console.error("District load error:", err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
        localStorage.clear();
        navigate("/suda/login");
      } else if (err.response?.status === 422) {
        Swal.fire(
          "Validation Failed",
          err.response.data?.message || "Invalid request",
          "warning"
        );
      } else {
        Swal.fire("Alert!", "Failed to load districts", "error");
      }
    }
  };


  const fetchSubdivisionList = async (districtId) => {
  if (!districtId) {
    setSubDivisions([]);
    return;
  }

  try {
    const res = await axios.post(
      `${BASE_URL}/subDivisionList`,
      { district_id: districtId },
      getAuthHeader()
    );

    setSubDivisions(res.data?.data || []);
  } catch (err) {
    console.error("Subdivision load error:", err);
    Swal.fire("Alert", "Failed to load subdivisions", "error");
  }
};


const fetchCircleList = async (subDivisionId) => {
  if (!subDivisionId) {
    setcircleList([]);
    return;
  }

  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/circleMasterList`,
      {
        sub_division_id: subDivisionId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setcircleList(res.data?.data || []);
  } catch (err) {
    console.log("Circle load error:", err);
    Swal.fire("Alert", "Failed to load circles", "error");
  }
};


  const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  const loadMunicipalities = async (pageNo = 1, searchValue = filters.searchKey, districtId = filters.district_id) => {
  try {
    setLoading(true);

    const res = await axios.post(
      `${BASE_URL}/municipalityList`,
      {
        searchKey: searchValue,
        district_id: districtId || "",
        page: pageNo,
        per_page: perPage
      },
      getAuthHeader()
    );

    setMunicipalities(res.data?.data || []);
    setPage(res.data?.page || pageNo);

    const totalRecords = res.data?.total_records || 0;
    const perPageValue = res.data?.per_page || perPage;
    const totalPagesCalculated = Math.ceil(totalRecords / perPageValue);

    setTotalRecords(totalRecords);
    setTotalPages(totalPagesCalculated);


  } catch (err) {

    if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      localStorage.clear();
      navigate("/suda/login");
    } else if (err.response?.status === 422) {
      Swal.fire(
        "Validation Failed",
        err.response.data?.message || "Invalid request",
        "warning"
      );
    } else {
      Swal.fire("Alert!", "Failed to load municipalities", "error");
    }
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {
    loadDistricts();
  }, []);

 // DISTRICT → SUBDIVISION
useEffect(() => {
  if (!formData.district_id) {
    setSubDivisions([]);
    setcircleList([]);
    return;
  }

  fetchSubdivisionList(formData.district_id);
}, [formData.district_id]);


// SUBDIVISION → CIRCLE
useEffect(() => {
  if (!formData.sub_division_id) {
    setcircleList([]);
    return;
  }

  fetchCircleList(formData.sub_division_id);
}, [formData.sub_division_id]);







  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      user_id: "",
      district_id: "",
      name: "",
    //   sub_division_id: "",
      password: "",
      confirm_password: "",
      municipality_code: "",
      address: ""
    });
    setShowModal(true);
  };

 const openEditModal = (row) => {
  console.log("EDIT ROW 👉", row); // 🔥 ADD THIS

  setIsEdit(true);
  setShowModal(true);

  setFormData({
    user_id: row.user_id,
    district_id: row.district_id || "",
    // sub_division_id: row.sub_division_id || "",
    // circle_id: row.circle_id || "",
    name: row.name || "",
    municipality_code: row.username || "",
    // email: row.email || "",
    // mobile: row.mobile || "",
    address: row.address || "",
    password: "",
    confirm_password: "",
  });
};






  /*  SAVE */
  const handleSave = async () => {
  // ---------- COMMON VALIDATION ----------



  if (!isEdit && (!formData.password || !formData.confirm_password)) {
    return Swal.fire("Warning!", "Password is required", "warning");
  }

  if (
    formData.password &&
    formData.password !== formData.confirm_password
  ) {
    return Swal.fire("Warning!", "Passwords do not match", "warning");
  }

  const payload = {
    district_id: Number(formData.district_id),
    // sub_division_id: Number(formData.sub_division_id),
    name: formData.name,
    municipality_code: formData.municipality_code,
    // circle_id: formData.circle_id,
    email: formData.email,
    mobile: formData.mobile,
    address: formData.address,
  };

  if (formData.password) {
    payload.password = formData.password;
    payload.confirm_password = formData.confirm_password;
  }

  if (isEdit) {
      payload.user_id = formData.user_id;
      console.log(payload.user_id)

  }



  try {
      const res = await axios.post(
    `${BASE_URL}/municipalityAddEdit`,
    payload,
    getAuthHeader()
  );

  // 🔥 Handle API status false (optional but safe)
  if (res.data?.status === false) {
    return Swal.fire(
      "Warning!",
      res.data?.message || "Operation failed",
      "warning"
    );
  }

  const apiMessage =
    res.data?.message ||
    (isEdit
      ? "Municipality updated successfully"
      : "Municipality added successfully");

  Swal.fire("Success!", apiMessage, "success");

  setShowModal(false);
  loadMunicipalities(page, filters.searchKey, filters.district_id);


  } catch (err) {
    console.error("Save error:", err);

    if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    } else if (err.response?.status === 422) {
      Swal.fire(
        "Validation Failed",
        err.response.data?.message || "Invalid data submitted",
        "warning"
      );
    } else {
      Swal.fire("Alert!", "Operation failed. Try again.", "error");
    }
  }
};


  /* DELETE */
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This record will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(
            `${BASE_URL}api/municipalities/${id}`,
            getAuthHeader()
          );
          Swal.fire("Deleted!", "Municipality has been deleted.", "success");
          loadMunicipalities();
        } catch (err) {
          console.error("Delete error:", err);

          if (err.response?.status === 401) {
            Swal.fire("Session Expired", "Please login again", "warning");
            localStorage.clear();
            localStorage.clear();
            navigate("/suda/login");
          } else {
            Swal.fire("Alert!", "Failed to delete", "error");
          }
        }
      }
    });
  };

  useEffect(() => {
    loadMunicipalities(1);
  }, [perPage]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>

      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Municipality Master
          </h5>
        </div>
        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter municipality..."
                  value={filters.searchKey}
                  onChange={(e) =>
                    setFilters({ ...filters, searchKey: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">District</Form.Label>
                <Form.Select
                  value={filters.district_id}
                  onChange={(e) =>
                    setFilters({ ...filters, district_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select District</option>
                  {districts.map((d) => (
                    <option value={d.id} key={d.id}>
                      {d.name || d.district_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
                          <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

    <Form.Select
     style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
      value={perPage}
      onChange={(e) => {
        const value = Number(e.target.value);
        setPerPage(value);
        setPage(1);

      }}

    >
      <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
    </Form.Select>
    </Form.Group>
  </Col>


            <Col md={4} className="d-flex gap-3 mt-3">
              {/* SEARCH */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => loadMunicipalities(1,filters.searchKey)}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET */}
              <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    // Reset filters and pagination
    setFilters({ searchKey: "", district_id: "" });
    setPage(1);
    setPerPage(10);

    // Explicitly call API with empty filters
    loadMunicipalities(1, "", "");
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Button
        className="mb-3 px-4 text-white fw-semibold"
        onClick={openAddModal}
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #1B5E20, #2E7D32)";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 22px rgba(46,125,50,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2E7D32, #66BB6A)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(46,125,50,0.4)";
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add Municipality
      </Button>

       {/* <Button
        className="mb-3 px-4 text-white fw-semibold ms-2"
        style={{
          background: "linear-gradient(135deg, #1565C0, #42A5F5)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(21,101,192,0.4)",
        }}
        onClick={() => setShowImportModal(true)}
      >
        <i className="fa-solid fa-file-import me-2"></i> Import CSV
      </Button> */}






      {/* TABLE */}

      {loading && (
  <div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">Loading, please wait...</p>
  </div>
)}


    {!loading && (
        <Card
            className="mb-4 border-0"
            style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
            overflow: "hidden",
            }}
        >
            <Table bordered hover responsive striped>
            <thead className="table-primary">
                <tr>
                <th
                    style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                    }}
                >
                    SL No.
                </th>
                <th
                    style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                    }}
                >
                    Municipality
                </th>

                <th style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                    }}>Municipality Code (userid)</th>
                <th
                    style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                    }}
                >
                    District
                </th>



                <th
                    style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                    }}
                >
                    Action
                </th>
                </tr>
            </thead>

            <tbody>
                {municipalities.length > 0 ? (
                municipalities.map((item, index) => (
                    <tr key={item.id}>
                    <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>
                                        <td className="text-center">{item.name}</td>
                                        <td className="text-center">{item.username}</td>

                    <td className="text-center">
                        {item.district_name}
                    </td>


                    <td className="text-center">
                        <Button
                        size="sm"
                        className="me-2"
                        style={{
                            background: "#1565C1",
                            border: "none",
                            padding: "6px 10px",
                            boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#0D47A1")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "#1565C1")
                        }
                        onClick={() => openEditModal(item)}
                        >
                        <i className="fa-solid fa-pen text-white"></i>
                        </Button>

                        {/* DELETE */}
                        {/* <Button
                        size="sm"
                        style={{
                            background: "linear-gradient(90deg, #E53935, #D32F2F)",
                            border: "none",
                            padding: "6px 10px",
                            boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.background =
                            "linear-gradient(90deg, #D32F2F, #B71C1C)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.background =
                            "linear-gradient(90deg, #E53935, #D32F2F)")
                        }
                 onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}
                        >
                        <i className="fa-solid fa-trash-can text-white"></i>
                        </Button> */}
                    </td>
                    </tr>
                ))
                ) : (
                <tr>
                    <td colSpan="5" className="text-center text-muted py-4">
                    No data available
                    </td>
                </tr>
                )}
            </tbody>
            </Table>

             {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <nav>
                    <ul className="pagination shadow-sm">

                        {/* First */}
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => loadMunicipalities(1)}>
                            «
                        </button>
                        </li>

                        {/* Prev */}
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => loadMunicipalities(page - 1)}
                        >
                            ‹
                        </button>
                        </li>

                        {/* Page Numbers */}
                        {getPageNumbers().map((p) => (
                        <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                            <button
                            className="page-link"
                            onClick={() => loadMunicipalities(p)}
                            >
                            {p}
                            </button>
                        </li>
                        ))}

                        {/* Next */}
                        <li
                        className={`page-item ${
                            page === totalPages ? "disabled" : ""
                        }`}
                        >
                        <button
                            className="page-link"
                            onClick={() => loadMunicipalities(page + 1)}
                        >
                            ›
                        </button>
                        </li>

                        {/* Last */}
                        <li
                        className={`page-item ${
                            page === totalPages ? "disabled" : ""
                        }`}
                        >
                        <button
                            className="page-link"
                            onClick={() => loadMunicipalities(totalPages)}
                        >
                            »
                        </button>
                        </li>

                    </ul>
                    </nav>
                </div>
             )}

        </Card>
    )}

      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg"  backdrop="static"
  keyboard={false} >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "white" }}
        >
          <Modal.Title>
            {isEdit ? "Edit Municipality" : "Add Municipality"}
          </Modal.Title>
        </Modal.Header>



        <Modal.Body>
          <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
            <Form.Label>Select District <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.district_id}
              onChange={(e) =>
    setFormData({
      ...formData,
      district_id: e.target.value,
      sub_division_id: "",
      circle_id: "",
    })
  }
            >
              <option value="">-- Select District --</option>
              {districts.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name || d.district_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
            </Col>
            {/* <Col md={6}>
             <Form.Group className="mb-3">
            <Form.Label>
              Sub Division <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Select
              value={formData.sub_division_id || ""}
              onChange={(e) =>
                setFormData({ ...formData, sub_division_id: e.target.value })
              }
            >
              <option value="">Select Sub Division</option>

              {subDivisions.map((sd) => (
                <option key={sd.id} value={sd.id}>
                  {sd.sub_division_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
            </Col> */}

<Col md={6}>
             <Form.Group className="mb-3">
            <Form.Label>Municipality Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              placeholder="Enter Municipality"
            />
          </Form.Group>
            </Col>

          </Row>


         <Row>

{/* <Col md={6}>
          <Form.Group className="mb-3">
  <Form.Label>
    Circle <span style={{ color: "red" }}>*</span>
  </Form.Label>

  <Form.Select
    value={formData.circle_id || ""}
    onChange={(e) =>
      setFormData({ ...formData, circle_id: e.target.value })
    }
  >
    <option value="">Select Circle</option>

    {circleList.map((ci) => (
      <option key={ci.id} value={ci.id}>
        {ci.circle_name}
      </option>
    ))}
  </Form.Select>
</Form.Group>

          </Col> */}


            <Col md={6}>
            <Form.Group className="mb-3">
  <Form.Label>
    Municipality Code <span className="text-danger">*</span>
  </Form.Label>
  <Form.Control
    type="text"
    value={formData.municipality_code}
    onChange={(e) =>
      setFormData({ ...formData, municipality_code: e.target.value })
    }
    placeholder="Enter Municipality Code"
  />
</Form.Group>

            </Col>

            <Col md={6}>
            <Form.Group className="mb-3">
  <Form.Label>
    Municipality UserId (Auto-fill)<span className="text-danger">*</span>
  </Form.Label>
  <Form.Control
    type="text"
    value={formData.municipality_code}
    onChange={(e) =>
      setFormData({ ...formData, municipality_code: e.target.value })
    }
    disabled
    placeholder="Enter Municipality Code"
  />
</Form.Group>
</Col>
         </Row>



          {/* PASSWORD (ADD MODE ONLY) */}
                      <Row>
                        <Col md={6}>

            <Form.Group className="mb-3">
  <Form.Label>
    Password <span className="text-danger">*</span>
  </Form.Label>

  <div className="position-relative">
    <Form.Control
      type={showPassword ? "text" : "password"}
      value={formData.password}
      onChange={(e) =>
        setFormData({ ...formData, password: e.target.value })
      }
      placeholder="Enter Password"
      className="pe-5"
    />

    <i
      className={`fa-solid ${
        showPassword ? "fa-eye-slash" : "fa-eye"
      } position-absolute top-50 end-0 translate-middle-y me-3`}
      style={{ cursor: "pointer" }}
      onClick={() => setShowPassword(!showPassword)}
    ></i>
  </div>
</Form.Group>
</Col>

                      <Col md={6}>

            <Form.Group className="mb-3">
  <Form.Label>
    Confirm Password <span className="text-danger">*</span>
  </Form.Label>

  <div className="position-relative">
    <Form.Control
      type={showConfirmPassword ? "text" : "password"}
      value={formData.confirm_password}
      onChange={(e) =>
        setFormData({ ...formData, confirm_password: e.target.value })
      }
      placeholder="Enter Confirm Password"
      className="pe-5"
    />

    <i
      className={`fa-solid ${
        showConfirmPassword ? "fa-eye-slash" : "fa-eye"
      } position-absolute top-50 end-0 translate-middle-y me-3`}
      style={{ cursor: "pointer" }}
      onClick={() =>
        setShowConfirmPassword(!showConfirmPassword)
      }
    ></i>
  </div>
</Form.Group>
</Col>
                      </Row>


            <Form.Group className="mb-3">
              <Form.Label>Address <span className="text-danger">*</span></Form.Label>
              <Form.Control
              as="textarea"
    rows={3}
                type="text"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                 placeholder="Enter Address"

              />
            </Form.Group>

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} className="btn btn-danger text-white">Cancel</Button>
          <Button className="btn-success text-white" onClick={handleSave}>
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

       <Modal
        show={showImportModal}
        onHide={() => setShowImportModal(false)}
        size="lg"
        centered  backdrop="static"
  keyboard={false}
      >
        <Modal.Header closeButton style={{ background: "#1565C1", color: "white" }}>
          <Modal.Title>Import Municipalities from CSV</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Upload CSV File</Form.Label>
            <Form.Control
              type="file"
              accept=".csv"
              onChange={(e) => setCsvFile(e.target.files[0])}
            />
          </Form.Group>

          {csvFile && (
            <Button variant="info" >
              Preview
            </Button>
          )}

          {previewData.length > 0 && (
            <>
              <hr />
              <h6>Preview</h6>

              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>School Name</th>
                    <th>Code</th>
                    <th>Address</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {previewData.map((row, i) => (
                    <tr key={i}>
                      <td>{row.name}</td>
                      <td>{row.code}</td>
                      <td>{row.address}</td>
                      <td>
                        {row.error ? (
                          <span className="text-danger">{row.error}</span>
                        ) : (
                          <span className="text-success">OK</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImportModal(false)}>
            Cancel
          </Button>

          <Button
            variant="success"
            disabled={csvErrors.length > 0 || previewData.length === 0}
          //   onClick={handleImportCSV}
          >
            Import
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FilterTableUI;
